import(/* webpackMode: "eager", webpackExports: ["Breadcrumb","Divider","Skeleton"] */ "__barrel_optimize__?names=Breadcrumb,Divider,Skeleton!=!/root/workspace/bravve-independent-station-web_jyzf/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/node_modules/next-axiom/dist/webVitals/components.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/workspace/bravve-independent-station-web_jyzf/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/[category]/pdp/[slug]/index.css");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/assets/common/NotFound.png");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/assets/common/product_unavailable.png");
;
import(/* webpackMode: "eager", webpackExports: ["ImagesGallery"] */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/components/carousel/ImagesGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductListCarousel"] */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/components/carousel/ProductListCarousel/index.tsx");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/components/common/Register/RegisterModal.tsx");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/components/layout-widgets/category/index.tsx");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/components/layout-widgets/footer/index.tsx");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/components/layout-widgets/header.tsx");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/components/layout-widgets/header1.tsx");
;
import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/components/layout-widgets/search/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CollapseComponent"] */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/components/productDetail/CollapseComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductPrice"] */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/components/productPrice/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Reviews"] */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/components/reviews/index.tsx");
